import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { selectInDisplayContent } from '../../features/displayContent/selectors'
import { RetinalImagingContent } from '../../model/model'
import {
	FirstLine,
	ImagesBox,
	SecondLine,
	ThirdLine,
	TitleWrapper,
	Wrapper,
} from './CommonComponents'
import MediaBox from './MediaBox'

const isRetinalImagingContent = (
	content?: any,
): content is RetinalImagingContent => content?.section === 'retinalImaging'

export const RetinalImaging: React.FC = () => {
	const { t } = useTranslation()
	const displayContent = useSelector(selectInDisplayContent)

	const data = displayContent?.data
	return (
		<Wrapper>
			<TitleWrapper>
				<FirstLine>{t('content.clinicalData')}</FirstLine>
				<SecondLine>{t('content.retinalImaging')}</SecondLine>
				<ThirdLine>{t('content.retinalImagingInfo')}</ThirdLine>
			</TitleWrapper>
			{isRetinalImagingContent(data) && (
				<ImagesBox className="vertical">
					<MediaBox media={data.content.OD} />
					<MediaBox media={data.content.OS} />
				</ImagesBox>
			)}
		</Wrapper>
	)
}

export default RetinalImaging
